module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Regular.ed1d014b.ttf";